module.exports = __webpack_public_path__ + "img/Craig_Zingerline.jpeg";